import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { ControlPanelService } from 'src/states/control-panel.service';

@Pipe({
  name: 'authenticate'
})
export class AuthImagePipe implements PipeTransform {

  constructor(
    private http: HttpClient,
    private controlPanelService: ControlPanelService,
  ) {}

  async transform(src: string): Promise<string> {

    // console.log(src);

    const headers = new HttpHeaders({'Authorization': 'Bearer ' + this.controlPanelService.token});
    const imageBlob = await this.http.get(src, {headers, responseType: 'blob'}).toPromise();
    const reader = new FileReader();

    return new Promise((resolve, reject) => {

      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(imageBlob);
    });
  }
}

